import { Navigate } from "react-router-dom";
import { useAuth } from "context/AuthContext";
import { getRoleHomePath } from "utils/paths";
import { LoadingScreen } from "./shared/LoadingScreen";

export function HomeRedirect() {
  const { user, isLoading } = useAuth();

  if (isLoading) return <LoadingScreen fullPage message="Loading..." />;

  return <Navigate to={getRoleHomePath(user?.role)} replace />;
}
